import request from 'superagent';

export default async function getPerimeters({ selectedChildren = [], parent, qExpansion }) {
  const hkeysArray = selectedChildren.length > 0 ? selectedChildren.map((c) => c.hkey) : [parent.hkey];

  const res = await request
    .post('/portal-srp/api/v1/smartsuggest/getperimeters')
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json')
    .send(JSON.stringify({ hkeysArray, qExpansion }))
    .withCredentials();

  if (res.ok) {
    return res.body.polygons;
  }
}
